// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)

export class TssPreInitializationTMO {
	public id?: string = undefined;

	public mode?: TssPreInitializationModeEnum = undefined;

	public status?: TssPreInitializationStatusEnum = undefined;
}

export class TssPreInitializationRequestTMO {
	public mode?: TssPreInitializationModeEnum = undefined;

	public ersSecret?: string = undefined;
}


// MODEL USED IN APPLICATION (with additional properties)
export class TssPreInitialization extends TssPreInitializationTMO {}

export class TssPreInitializationRequest extends TssPreInitializationRequestTMO {
	public id?: string = undefined;

	public etag?: string = undefined;
}


// INTERFACES ########################################################
// API interfaces ****************************************************

// UI interfaces *****************************************************

// ENUMS #############################################################
// API enums *********************************************************

export enum TssPreInitializationModeEnum {
	ERS = 'ers',
	BUSINESS_PREMISES = 'businessPremises',
	TSS = 'tss'
}

export enum TssPreInitializationStatusEnum {
	PROCESSING = 'processing',
	FINISHED = 'finished',
	ERROR = 'error'
}

// UI enums *********************************************************
